import { useState } from "react";
import { useSelector } from "react-redux";
import Popover from "@mui/material/Popover";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { RootState } from "../../state/store";
import { NEUTRAL_ZONE_CHIP, ZONE_CHIP, ZoneChip } from "../ZoneChip/ZoneChip";

export function HeaderZones() {
  const user = useSelector((s: RootState) => s.authReducer.user);
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (!user) return null;
  if (user.isSuperAdmin) return <span className={`${ZONE_CHIP} ${NEUTRAL_ZONE_CHIP}`}>All zones</span>;

  const zones = user.zones;
  if (zones.length === 0) return null;
  if (zones.length === 1) return <ZoneChip name={zones[0].zone} colour={zones[0].hexColour} />;

  return (
    <>
      <button
        type="button"
        aria-haspopup="true"
        onClick={e => setAnchor(e.currentTarget)}
        className={`${ZONE_CHIP} ${NEUTRAL_ZONE_CHIP} gap-1 cursor-pointer`}
      >
        {zones.length} zones
        <FontAwesomeIcon icon={faChevronDown} className="!w-2 !h-2" />
      </button>

      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <ul aria-label="Your zones" className="flex flex-col gap-1 p-2 compact:gap-0 compact:p-1.5 bg-theme-surface-2 border border-theme-border">
          {zones.map(zone => (
            <li key={zone.zoneId}><ZoneChip name={zone.zone} colour={zone.hexColour} /></li>
          ))}
        </ul>
      </Popover>
    </>
  );
}
